import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vcqpcnsjcq: FaireBrandEntity = {
  token: "b_vcqpcnsjcq",
  type: "brand",
  name: "The Minimalist Ceramist",
  avatarUrl:
    "https://cdn.faire.com/fastly/f788e941ccd1fbfa14b054f88bd0af6aa12b95f12606759092627f29271bf633.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3a2eaa05f51edb1c893d4efe573d883878ac58a58c20c3a4c25c312c29cfdeda.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f788e941ccd1fbfa14b054f88bd0af6aa12b95f12606759092627f29271bf633.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3a2eaa05f51edb1c893d4efe573d883878ac58a58c20c3a4c25c312c29cfdeda.jpeg",
  location: "Novato, CA, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 20,
  isInsider: true,
  description:
    "Hey there! I'm Tess, the creative force behind The Minimalist Ceramist. My journey into pottery began in 2021, seeking solace and inspiration amidst the pandemic chaos while raising my two little ones. Since then, I've immersed myself in the world of ceramics, from finding my place in a local studio to eventually crafting my own cozy home studio.\n\nInspired by my children's nature collections, I first embarked on creating curio shelves in 2022. Over the past two years, I've poured my heart into innovating and refining The Shelf of Inspiration, driven by a desire to capture the essence of childhood wonder while combining functionality with aesthetic appeal. In early 2024 launched my cement line in hopes of making my shelves more accessible. With these pieces I make the original out of ceramic, create a silicone mold and hand pour each cement shelf, which has been colored with powdered pigments. Every piece is handcrafted in my California studio and exudes the charm and uniqueness of a handmade item. My goal is simple: to bring the joy of the outdoors inside, creating pieces that evoke the same sense of awe and discovery we experience in nature.\n\nFocusing on sustainable studio and shipping practices is a top priority for me. I use all recyclable and compostable shipping materials, reusing what I have on hand whenever possible.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:09.193Z",
    importedBy: "entity-db-cli",
  },
};
